<template>
  <fragment>
    <v-col>
      <v-col>
        <v-row style="display: flex; align-items: center">
          <v-col cols="11">
            <label required class="input-labels"> {{ $t('sales.affiliates_program_affiliates') }} </label>
            <v-autocomplete
              v-model="selectedAffiliates"
              :items="allAffiliatesWithDefaultNameAndEmail"
              solo
              class="textDropdown"
              :label="$t('sales.affiliates_program_affiliates_placeholder')"
              chip
              multiple
              deletable-chips
              :item-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              clear-icon="mdi-close-circle-outline"
              :no-data-text="$t('sales.affiliates_program_no_affiliates')"
              :item-text="displayAffiliateInfo"
              item-value="email"
              return-object
              @input="selectedAffiliatesError = ''"
              :error-messages="selectedAffiliatesError"
            >
              <template v-slot:selection="{ item }">
                <v-chip close @click:close="removeAffiliate(item)">{{
                  item.nome || "Nome não indefinido"
                }}</v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="1">
            <v-icon class="icon-plus" @click="setDialogPreRegister(true)"
              >mdi-plus</v-icon
            >
          </v-col>
        </v-row>
        <v-alert
          class="mb-8"
          border="left"
          colored-border
          type="info"
          elevation="2"
        >
          {{ $t('sales.affiliates_program_affiliates_info') }}
        </v-alert>
      </v-col>
      <v-col
        ><v-btn
          class="btn-color"
          :color="$config.dados.corinputs"
          style="color: white"
          @click="handleSubmitForm()"
        >
          {{ $t('sales.affiliates_program_continue') }}
        </v-btn>
        <v-btn text @click="stepBackProgram()"> {{ $t('sales.affiliates_program_return') }} </v-btn></v-col
      >
    </v-col>
    <AffiliatesSettings />
  </fragment>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import AffiliatesSettings from "@/views/people/AffiliatesSettings.vue";

export default {
  name: "Affiliates",
  components: {
    AffiliatesSettings,
  },
  data() {
    return {
      selectedAffiliates: [],
      selectedAffiliatesError: "",
      status: [
        { text: "Ativo", value: "ATIVO" },
        { text: "Inativo", value: "INATIVO" },
      ],
      rules: {
        required: value => !!value || this.$t('sales.affiliate_required'),
        email: value => {
          const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return pattern.test(value) || this.$t('sales.affiliate_email_validation');
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      "allEvents",
      "allAffiliates",
      "dataProgram",
      "idProgramTemp",
      "affiliatesByProgram",
      "stepProgram",
      "dialogPreRegister",
    ]),
    allAffiliatesWithDefaultNameAndEmail() {
      return this.allAffiliates.map(affiliate => {
        if (affiliate.nome === "") {
          return {
            ...affiliate,
            nome: "Nome indefinido",
            email: affiliate.email,
          };
        }
        return { ...affiliate, email: affiliate.email };
      });
    },
  },
  methods: {
    ...mapActions([
      "fetchAllAffiliates",
      "createAffiliate",
      "nextStepProgram",
      "stepBackProgram",
      "showSnackbarError",
      "showSnackbarSuccess",
      "getAffiliatesByProgram",
    ]),
    ...mapMutations(["setDataProgram", "setDialogPreRegister"]),
    handleSubmitForm() {
      if (this.selectedAffiliates.length === 0) {
        this.showSnackbarError(this.$t('sales.affiliates_program_affiliates_validation'));
        this.selectedAffiliatesError = this.$t('sales.affiliates_program_affiliates_validation');
        return;
      }
      this.setDataProgram({
        ...this.dataProgram,
        affiliates: this.selectedAffiliates,
        emails: this.selectedAffiliates.map(affiliate => affiliate.email),
      });
      this.nextStepProgram();
    },
    displayAffiliateInfo(item) {
      return `${item.nome || "Nome não indefinido"} - ${item.email}`;
    },
    removeAffiliate(item) {
      this.selectedAffiliates = this.selectedAffiliates.filter(
        i => i.idafiliado !== item.idafiliado
      );
    },
  },
  mounted() {
    this.fetchAllAffiliates({
      loja: "",
      limite: 1000,
      pagina: 1,
      status: "",
      name: "",
    });
  },
  watch: {
    "$store.getters.dataProgram": {
      handler: function (val) {
        if (this.affiliatesByProgram.length <= 0 && this.stepProgram === 1) {
          this.getAffiliatesByProgram({ id: val?.idprograma });
        }
        if (this.selectedAffiliates.length === 0) {
          this.selectedAffiliates = this.affiliatesByProgram.filter(
            affiliate => affiliate.status !== "INATIVO"
          );
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.icon-plus {
  color: white;
  font-size: 28px;
  cursor: pointer;
  background-color: #2d1a4c;
  border-radius: 50%;
}
.icon-plus:hover {
  opacity: 0.7;
}
.icon-plus:active {
  background-color: #353535;
  opacity: 1;
}
</style>
